import { useEffect } from "react";
import { API_BASE_URL } from "../api/config";

const Login = ({ onLogin }) => {
    useEffect(() => {
        window.onTelegramAuth = (user) => {
            fetch(`${API_BASE_URL}/auth/telegram/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(user)
            })
            .then(res => {
                console.log('status:', res.status)
                return res.json()
            })
            .then(data => {
                console.log('response data:', data)
                if (data.token) {
                    localStorage.setItem('token', data.token);
                    localStorage.setItem('name', data.name);
                    onLogin();
                } else {
                    alert('Access denied. You are not an admin.');
                }
            })
            .catch(err => {
                console.log('error:', err)
                alert('Login failed. Try again.');
            });
        };

        const script = document.createElement('script');
        script.src = 'https://telegram.org/js/telegram-widget.js?22';
        script.setAttribute('data-telegram-login', 'cleaningmiamidevbot');
        script.setAttribute('data-size', 'large');
        script.setAttribute('data-onauth', 'onTelegramAuth(user)');
        script.setAttribute('data-request-access', 'write');
        script.async = true;
        document.getElementById('telegram-login').appendChild(script);

        return () => {
            delete window.onTelegramAuth;
        };
    }, [onLogin]);
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-background-600">
            <div className="bg-primary-800 rounded-2xl p-8 w-full max-w-sm mx-4">
                <h1 className="text-white text-2xl font-bold mb-2 text-center">Admin Panel</h1>
                <p className="text-primary-50 text-xs font-mono text-center mb-8">CLEANING MIAMI</p>
                <div id='telegram-login' className="flex justify-center" />
            </div>
        </div>
    );
};

export default Login;